export const ATTACHMENTS_MAX_COUNT = 25;
export const ATTACHMENTS_MAX_SIZE = 50 * 1024 * 1024;
export const ATTACHMENTS_MAX_SIZE_TOTAL = 100 * 1024 * 1024;
